import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

export type BlotterReferentialApi = {
  getTradesBlottersAvailablePlatforms(): Observable<string[]>;
  getQuoteBlotterAvailablePlatforms(): Observable<string[]>;
};

export type PlatformResponse = {
  platforms: string[];
};

export function referentialApiConnector(http: IHttpClient): BlotterReferentialApi {
  return {
    getTradesBlottersAvailablePlatforms() {
      return http
        .getJSON<PlatformResponse>({
          url: 'api/v1/blotter/platforms/trades',
        })
        .pipe(map(({ payload }) => payload.platforms));
    },
    getQuoteBlotterAvailablePlatforms() {
      return http
        .getJSON<PlatformResponse>({
          url: 'api/v1/blotter/platforms/quotes',
        })
        .pipe(map(({ payload }) => payload.platforms));
    },
  };
}
